function substituteVars(url, vars) {
  return Object.keys(vars).reduce(
    (cum, key) =>
      cum.replace(new RegExp('\\${' + key + '}', 'gi'), vars[key]),
    url
  );
}

module.exports = {
  substituteVars
}